import {isDonationTicketDefinition} from '@wix/wix-events-commons-statics'
import {TFunction} from '@wix/yoshi-flow-editor'
import {State} from '../../types'
import {PriceFormatters} from '../../../../../commons/hooks/currency'
import {getPlaceTicketPriceText} from './place'
import {getTicketDefinitionByExternalId} from './seating'

export interface LegendItem {
  name: string
  color: string
  price: string
}

export const getLegendItems = (
  state: State,
  t: TFunction,
  {getTicketPriceText, getFormattedMoney}: PriceFormatters,
): LegendItem[] =>
  state.seating.plan.categories
    .filter(category => Boolean(category.places.length))
    .map(({externalId, config: {color}}) => {
      const ticketDefinition = getTicketDefinitionByExternalId(state.tickets, externalId)

      if (!ticketDefinition) {
        return null
      }

      const isDonation = isDonationTicketDefinition(ticketDefinition)

      return {
        name: ticketDefinition.name,
        color,
        price: getPlaceTicketPriceText({
          ticket: ticketDefinition,
          t,
          getTicketPriceText,
          getFormattedMoney,
        }),
        amount: isDonation ? 0 : Number(ticketDefinition.price.amount),
      }
    })
    .filter(Boolean)
    .sort((a, b) => a.amount - b.amount)
